module.exports = __webpack_public_path__ + "static/media/signage-industrial-img15.74c8e0b8.jpg";